export type Movie = {
  id: number;
  title: string;
  originalTitle: string;
  year: number;
  genres: string[];
  rating: number;
  quality: string;
  resolution: string;
  size: string;
  region: string;
  duration: string;
  heat: number;
  desc: string;
  poster: string;
  updated: string;
};

export const movieList: Movie[] = [
  {
    id: 1,
    title: '星海迷航',
    originalTitle: 'Stellar Voyage',
    year: 2025,
    genres: ['科幻', '冒险'],
    rating: 8.7,
    quality: '4K蓝光',
    resolution: '3840×2160',
    size: '18.6 GB',
    region: '美国',
    duration: '142 分钟',
    heat: 98,
    desc: '一支远航船队在星门失联后被卷入未知星域，船员必须在有限的氧气与信任之间做出抉择。影片以扎实的硬科幻设定与克制的情绪铺陈，呈现一场关于孤独与归途的太空漂流。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20drifting%20before%20a%20giant%20ringed%20planet%2C%20dramatic%20rim%20lighting%2C%20warm%20amber%20and%20crimson%20color%20grading%2C%20delicate%20film%20grain%20texture%2C%20minimal%20dark%20composition%2C%20high%20detail%20painterly%20illustration&width=400&height=600&seq=movie-poster-01&orientation=portrait',
    updated: '10-08',
  },
  {
    id: 2,
    title: '暗夜追凶',
    originalTitle: 'Night Pursuit',
    year: 2025,
    genres: ['悬疑', '犯罪'],
    rating: 8.4,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '6.2 GB',
    region: '中国香港',
    duration: '118 分钟',
    heat: 95,
    desc: '雨夜连环案让一名即将退休的老刑警重新披挂上阵，线索指向十年前被他亲手结案的旧卷宗。潮湿街巷与冷静推演交替推进，把真相一点点逼到台前。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20noir%20crime%20movie%20poster%20artwork%20of%20a%20silhouetted%20detective%20under%20rain%20in%20a%20narrow%20alley%2C%20deep%20shadows%2C%20warm%20amber%20streetlight%20glow%2C%20crimson%20accent%2C%20moody%20film%20grain%2C%20minimal%20dark%20composition%2C%20high%20detail%20painterly%20illustration&width=400&height=600&seq=movie-poster-02&orientation=portrait',
    updated: '10-07',
  },
  {
    id: 3,
    title: '山河故人录',
    originalTitle: 'Chronicle of Rivers and Mountains',
    year: 2024,
    genres: ['剧情', '历史'],
    rating: 9.1,
    quality: '4K蓝光',
    resolution: '3840×2160',
    size: '22.4 GB',
    region: '中国',
    duration: '156 分钟',
    heat: 92,
    desc: '以一座南方小镇三代人的迁徙为主线，影片用长达半个世纪的时间跨度勾勒普通家庭的聚散。四季实景与静默长镜头让历史不再是背景，而成为每个人身上的年轮。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20epic%20drama%20movie%20poster%20artwork%20of%20a%20lone%20figure%20standing%20on%20a%20misty%20river%20bank%20at%20dawn%2C%20soft%20golden%20light%2C%20warm%20amber%20and%20earthy%20tone%2C%20subtle%20crimson%20accent%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-03&orientation=portrait',
    updated: '10-05',
  },
  {
    id: 4,
    title: '光年之外',
    originalTitle: 'Beyond Light Years',
    year: 2025,
    genres: ['科幻', '爱情'],
    rating: 7.9,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '5.8 GB',
    region: '中国',
    duration: '129 分钟',
    heat: 88,
    desc: '一次为期二十年的深空任务，让一对恋人被迫在时间的两端各自老去。影片用通讯延迟制造情感张力，把“等待”拍成了一种可以丈量的距离。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20romantic%20sci-fi%20movie%20poster%20artwork%20of%20two%20small%20figures%20reaching%20toward%20each%20other%20across%20a%20vast%20glowing%20nebula%2C%20warm%20amber%20and%20crimson%20gradient%2C%20soft%20light%20streaks%2C%20film%20grain%2C%20minimal%20dark%20composition%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-04&orientation=portrait',
    updated: '10-06',
  },
  {
    id: 5,
    title: '龙脊行动',
    originalTitle: 'Operation Dragon Ridge',
    year: 2025,
    genres: ['动作', '战争'],
    rating: 8.2,
    quality: '4K蓝光',
    resolution: '3840×2160',
    size: '20.1 GB',
    region: '中国',
    duration: '134 分钟',
    heat: 90,
    desc: '一支边境小队受命护送关键情报穿越封锁线，全程以真实地形实拍，动作设计强调战术逻辑而非炫技。群像刻画让每个角色都有可辨认的动机与代价。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20action%20war%20movie%20poster%20artwork%20of%20soldiers%20advancing%20through%20smoke%20on%20a%20rugged%20ridge%20at%20dusk%2C%20dramatic%20backlight%2C%20warm%20amber%20and%20crimson%20orange%20hues%2C%20film%20grain%20texture%2C%20minimal%20dark%20composition%2C%20high%20detail%20painterly%20illustration&width=400&height=600&seq=movie-poster-05&orientation=portrait',
    updated: '10-08',
  },
  {
    id: 6,
    title: '无声之城',
    originalTitle: 'The Silent City',
    year: 2024,
    genres: ['悬疑', '剧情'],
    rating: 8.6,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '6.7 GB',
    region: '韩国',
    duration: '121 分钟',
    heat: 84,
    desc: '整座城市在一夜之间失去所有声音，唯一能听见的少女成为解谜的钥匙。影片用近乎无声的声场设计重建观众的感知，悬念随静默层层收紧。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20mystery%20movie%20poster%20artwork%20of%20a%20girl%20standing%20in%20an%20empty%20foggy%20city%20street%20at%20night%2C%20single%20warm%20amber%20glow%2C%20crimson%20accent%20light%2C%20eerie%20minimal%20dark%20composition%2C%20film%20grain%20texture%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-06&orientation=portrait',
    updated: '10-04',
  },
  {
    id: 7,
    title: '拾光纪',
    originalTitle: 'Memory Keeper',
    year: 2025,
    genres: ['动画', '家庭'],
    rating: 8.9,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '4.9 GB',
    region: '日本',
    duration: '108 分钟',
    heat: 86,
    desc: '在一座会遗忘事物的海边小镇，兄妹俩开着一间替人保管回忆的小店。手绘风格的暖色调画面搭配舒缓配乐，讲述关于成长与告别的温柔寓言，适合全家观看。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20hand-drawn%20animation%20movie%20poster%20artwork%20of%20two%20children%20by%20a%20glowing%20seaside%20town%20at%20sunset%2C%20warm%20amber%20and%20soft%20crimson%20sky%2C%20gentle%20painterly%20texture%2C%20minimal%20charming%20composition%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-poster-07&orientation=portrait',
    updated: '10-09',
  },
  {
    id: 8,
    title: '归途列车',
    originalTitle: 'The Homebound Train',
    year: 2024,
    genres: ['剧情', '公路'],
    rating: 8.1,
    quality: 'HD高清',
    resolution: '1280×720',
    size: '2.8 GB',
    region: '中国',
    duration: '116 分钟',
    heat: 78,
    desc: '一列即将停运的绿皮火车上，六位陌生旅客因一场大雪被迫同行。影片用一节车厢装下六段人生，缓慢而真诚地讨论“回家”这两个字的分量。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20road%20drama%20movie%20poster%20artwork%20of%20an%20old%20green%20train%20traveling%20through%20a%20snowy%20warm-lit%20landscape%2C%20amber%20window%20glow%2C%20soft%20crimson%20dusk%20sky%2C%20nostalgic%20film%20grain%2C%20minimal%20composition%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-08&orientation=portrait',
    updated: '10-03',
  },
  {
    id: 9,
    title: '深海回响',
    originalTitle: 'Echoes of the Deep',
    year: 2025,
    genres: ['冒险', '科幻'],
    rating: 8.3,
    quality: '4K蓝光',
    resolution: '3840×2160',
    size: '19.5 GB',
    region: '英国',
    duration: '138 分钟',
    heat: 82,
    desc: '深海科考队在八千米海沟捕捉到一段无法解释的规律声波。影片以逼真的水下摄影与音效设计营造压迫感，在探索未知与敬畏自然之间保持分寸。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20underwater%20adventure%20movie%20poster%20artwork%20of%20a%20small%20submarine%20descending%20into%20a%20glowing%20deep%20trench%20surrounded%20by%20dark%20water%2C%20warm%20amber%20sub%20lights%2C%20crimson%20accent%20glow%2C%20film%20grain%20texture%2C%20minimal%20composition%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-09&orientation=portrait',
    updated: '10-06',
  },
  {
    id: 10,
    title: '长安月明',
    originalTitle: "Moon Over Chang'an",
    year: 2024,
    genres: ['历史', '古装'],
    rating: 8.8,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '7.1 GB',
    region: '中国',
    duration: '148 分钟',
    heat: 80,
    desc: '以一位女画师的视角展开盛唐画卷，考据详尽的服化道与市井细节重建了当年的长安气象。影片在宏大叙事之外，把镜头留给普通人的日常与坚守。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20ancient%20chinese%20costume%20movie%20poster%20artwork%20of%20a%20lady%20in%20flowing%20robes%20under%20a%20huge%20warm%20moon%20above%20pagoda%20rooftops%2C%20golden%20amber%20lantern%20light%2C%20crimson%20accent%2C%20elegant%20film%20grain%20texture%2C%20minimal%20painterly%20illustration&width=400&height=600&seq=movie-poster-10&orientation=portrait',
    updated: '10-02',
  },
  {
    id: 11,
    title: '边境迷雾',
    originalTitle: 'Fog at the Frontier',
    year: 2025,
    genres: ['战争', '悬疑'],
    rating: 8.0,
    quality: '1080P蓝光',
    resolution: '1920×1080',
    size: '6.0 GB',
    region: '德国',
    duration: '125 分钟',
    heat: 75,
    desc: '一名哨兵在漫长的边境巡逻中逐渐分不清敌我，影片用冷峻的镜头语言探讨信任与恐惧的边界。开放式的结尾留给观众足够的回味空间。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20war%20thriller%20movie%20poster%20artwork%20of%20a%20lone%20soldier%20silhouette%20in%20dense%20fog%20on%20a%20border%20road%20at%20dawn%2C%20muted%20warm%20amber%20light%2C%20crimson%20accent%20glow%2C%20gritty%20film%20grain%2C%20minimal%20dark%20composition%2C%20painterly%20illustration&width=400&height=600&seq=movie-poster-11&orientation=portrait',
    updated: '10-07',
  },
  {
    id: 12,
    title: '笑看风云',
    originalTitle: 'Laughing Through the Storm',
    year: 2025,
    genres: ['喜剧', '剧情'],
    rating: 7.6,
    quality: 'HD高清',
    resolution: '1280×720',
    size: '2.4 GB',
    region: '中国',
    duration: '104 分钟',
    heat: 72,
    desc: '一个失败的中年小店主阴差阳错接手了一档即将被砍的深夜节目。影片不靠密集尬笑，而是用生活流的小幽默讲一个重新出发的故事，轻松又治愈。',
    poster: 'https://readdy.ai/api/search-image?query=stylized%20feel-good%20comedy%20movie%20poster%20artwork%20of%20a%20cheerful%20shopkeeper%20in%20a%20warm%20little%20storefront%20at%20evening%2C%20golden%20amber%20string%20lights%2C%20soft%20crimson%20accent%2C%20cozy%20painterly%20texture%2C%20minimal%20charming%20composition%2C%20high%20detail%20illustration&width=400&height=600&seq=movie-poster-12&orientation=portrait',
    updated: '10-09',
  },
];